import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendListModel } from 'src/app/models/common/list.model';
import { TransferReason } from 'src/app/models/transfer-reason';
import { TransferRequest } from 'src/app/models/transfer-request';
import { UserList } from 'src/app/models/user-list';
import { AckRequestService } from 'src/app/services/ack-request.service';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { MyOrdersService } from '../my-orders-table/my-orders-table.service';
import { Router } from '@angular/router';

@Component({
  selector: 'logzy-request-transfer-form',
  templateUrl: './request-transfer-form.component.html',
  styleUrls: ['../request-form.scss']
})
export class RequestTransferFormComponent implements OnInit {
  errorObj: any = {};
  modelService: MyOrdersService;
  ackService: AckRequestService;
  reason_List: BackendListModel<TransferReason>;
  user_List: BackendListModel<UserList>;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() updateAction: EventEmitter<any> = new EventEmitter();
  @Input() changeToStatus = null;

  userMaster_url = ApiRoutes.Company;

  constructor(private ackRequest: AckRequestService, private myOrderService: MyOrdersService
    , private snackBar: MatSnackBar,private router: Router) { }

  @Input()
  transferObject: TransferRequest;

  defaulttranfer: TransferRequest = {
    id: null,
    remarks: "OK",
    remove_request_from_allocated_user: false,
    add_user_to_similar_requests: false,
    allocated_to: null,
    transfer_reason: null
  }
  ngOnInit(): void {
    this.getTransferReasons();
    this.getUserList();
    this.transferObject = { ...this.defaulttranfer };
    this.modelService = this.myOrderService;
    this.ackService = this.ackRequest;
  }

  transferRequest(data) {
    // this.transferObject['allocated_to'] =this.transferObject.allocated_to?.id;
    this.ackRequest.transferRequest(data, this.ackService.selectedRequest.id).subscribe({
      next: response => {
        this.snackBar.open("Request Shared Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        // this.modelService.getRequestDetails();
        this.close.emit();
        this.updateAction.emit();
        this.router.navigateByUrl(`/requests/request-processing`);

      },
      error: error => {
        return this.catchError(error);
      }
    })
  }
  keysToTransform = [
    'allocated_to'
  ];
  saveRequest() {
    let payload = { ...this.transferObject };
    for (const key of this.keysToTransform) {
      if (payload[key] != null && payload[key] != '')
        payload[key] = payload[key].id;
    }
    this.transferRequest(payload);
  }
  //For Transfer Reason
  getTransferReasons() {
    this.ackRequest.getTransferReasons().subscribe(response => {
      this.reason_List = response;
    })
  }

  //Ger Users
  getUserList() {
    this.ackRequest.getUserList().subscribe(response => {
      this.user_List = response;
    })
  }
  // Function to catch errors
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    }
  }
}
